import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "search-form" }
const _hoisted_2 = {
  key: 1,
  class: "loading-state"
}
const _hoisted_3 = {
  key: 2,
  class: "results-container"
}
const _hoisted_4 = {
  key: 0,
  class: "summary-section"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "sources-section"
}
const _hoisted_7 = { class: "source-cards" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "source-index" }
const _hoisted_10 = { class: "index-number" }
const _hoisted_11 = { class: "source-info" }
const _hoisted_12 = { class: "source-name" }
const _hoisted_13 = {
  key: 0,
  class: "source-quote"
}
const _hoisted_14 = { class: "source-action" }
const _hoisted_15 = {
  key: 2,
  class: "no-results"
}
const _hoisted_16 = {
  key: 3,
  class: "initial-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_DocumentPreviewModal = _resolveComponent("DocumentPreviewModal")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isOpen) = $event)),
    "max-width": "800",
    class: "precedent-dialog-blur"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "precedent-modal" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "precedent-modal-header" }, {
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "material-symbols-outlined" }, "search", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "Emsal Karar Ara", -1)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                onClick: _ctx.close,
                size: "small"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("span", { class: "material-symbols-outlined" }, "close", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "precedent-modal-body" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.searchQuery,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  label: "Arama sorgusu",
                  placeholder: "Örn: trafik kazası tazminat, kira sözleşmesi feshi...",
                  variant: "outlined",
                  density: "comfortable",
                  "hide-details": "",
                  disabled: _ctx.loading,
                  onKeyup: _withKeys(_ctx.search, ["enter"]),
                  autofocus: ""
                }, {
                  "append-inner": _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "flat",
                      loading: _ctx.loading,
                      disabled: !_ctx.searchQuery || _ctx.searchQuery.length < 3,
                      onClick: _ctx.search,
                      size: "small"
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("span", { class: "material-symbols-outlined" }, "search", -1),
                        _createTextVNode(" Ara ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading", "disabled", "onClick"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "onKeyup"])
              ]),
              (_ctx.error)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "error",
                    variant: "tonal",
                    class: "mt-4",
                    closable: "",
                    "onClick:close": _cache[1] || (_cache[1] = ($event: any) => (_ctx.error = ''))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.error), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "primary"
                    }),
                    _cache[8] || (_cache[8] = _createElementVNode("span", null, "Emsal kararlar aranıyor...", -1))
                  ]))
                : (_ctx.hasSearched)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (_ctx.summary)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _cache[9] || (_cache[9] = _createElementVNode("h4", null, [
                              _createElementVNode("span", { class: "material-symbols-outlined" }, "summarize"),
                              _createTextVNode(" Özet ")
                            ], -1)),
                            _createElementVNode("div", {
                              class: "summary-content",
                              innerHTML: _ctx.summary
                            }, null, 8, _hoisted_5)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.results.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("h4", null, [
                              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "material-symbols-outlined" }, "folder_open", -1)),
                              _createTextVNode(" Kaynak Belgeler (" + _toDisplayString(_ctx.results.length) + ") ", 1)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "source-card",
                                  onClick: ($event: any) => (_ctx.selectResult(result))
                                }, [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("span", _hoisted_10, "[" + _toDisplayString(result.index || index + 1) + "]", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, _toDisplayString(result.file_name), 1),
                                    (result.quote)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, " \"" + _toDisplayString(_ctx.truncateText(result.quote, 150)) + "\" ", 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_v_btn, {
                                      variant: "tonal",
                                      color: "primary",
                                      size: "small",
                                      onClick: _withModifiers(($event: any) => (_ctx.addToChat(result)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                        _createElementVNode("span", { class: "material-symbols-outlined" }, "add_comment", -1),
                                        _createTextVNode(" Sohbete Ekle ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    _createVNode(_component_v_btn, {
                                      variant: "outlined",
                                      color: "primary",
                                      size: "small",
                                      onClick: _withModifiers(($event: any) => (_ctx.downloadFile(result)), ["stop"]),
                                      loading: _ctx.downloadingFile === result.file_name
                                    }, {
                                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                        _createElementVNode("span", { class: "material-symbols-outlined" }, "download", -1),
                                        _createTextVNode(" İndir ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["onClick", "loading"])
                                  ])
                                ], 8, _hoisted_8))
                              }), 128))
                            ])
                          ]))
                        : (!_ctx.summary)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[13] || (_cache[13] = [
                              _createElementVNode("span", { class: "material-symbols-outlined" }, "search_off", -1),
                              _createElementVNode("p", null, "Aramanızla eşleşen emsal karar bulunamadı.", -1)
                            ]))]))
                          : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("span", { class: "material-symbols-outlined" }, "gavel", -1),
                      _createElementVNode("p", null, "Emsal karar aramak için yukarıdaki alana anahtar kelimeler girin.", -1),
                      _createElementVNode("small", null, "Örnek: \"trafik kazası tazminat\", \"iş sözleşmesi feshi\", \"kira artış oranı\"", -1)
                    ]))]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "precedent-modal-footer" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode("Kapat", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_spacer),
              (_ctx.summary)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    variant: "tonal",
                    color: "primary",
                    onClick: _ctx.addSummaryToChat
                  }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("span", { class: "material-symbols-outlined" }, "add_comment", -1),
                      _createTextVNode(" Özeti Sohbete Ekle ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DocumentPreviewModal, {
        modelValue: _ctx.previewVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.previewVisible) = $event)),
        document: _ctx.selectedDocument,
        onAddToChat: _ctx.handlePreviewAddToChat
      }, null, 8, ["modelValue", "document", "onAddToChat"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}